export const DEPOFINANCE_COSMOS_VALIDATOR_ADDRESS =
  'cosmosvaloper199mlc7fr6ll5t54w7tts7f4s0cvnqgc59nmuxf'
export const DEPOFINANCE_OSMOSIS_VALIDATOR_ADDRESS =
  'osmovaloper1xf9zpq5kpxks49cg606tzd8qstaykxgt2vs0d5'
export const EMPTY_COSMOS_ADDRESS = 'cosmos1n89secc5fgu4cje3jw6c3pu264vy2yav2q5xpt'
export const EMPTY_OSMOSIS_ADDRESS = 'osmo1n89secc5fgu4cje3jw6c3pu264vy2yavzm8khe'
